import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Mridul Sharma </span>
            from <span className="purple"> Chamba, Himachal Pradesh, India.</span>
            <br />I am a senior pursuing B.Tech. in Electronics and Communication at NIT
            Hamirpur.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Board Games like Chess and Carrom
            </li>
            <li className="about-activity">
              <ImPointRight /> Painting and Sketching
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
            <li className="about-activity">
              <ImPointRight /> Playing Sports like Badminton and Basketball
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Hardwork is the key to Success"{" "}
          </p>
          <footer className="blockquote-footer">Mridul</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
